import Grid from "@material-ui/core/Grid/Grid";
import React, { PureComponent } from "react";

export default class Tips extends PureComponent {
  render() {
    return (
      <React.Fragment>
        <Grid item xs={12}>
          <h2 style={{ textAlign: "center" }}>Tips</h2>
        </Grid>
        <Grid item xs={12}>
          <ul>
            <li>Make sure you have high energy and sound natural</li>
            <li>
              Before recording, make sure to read the introduction out loud 2
              times
            </li>
            <li>
              <b>
                You are required to listen to the recording before uploading
              </b>
              (if it sounds scripted, redo it and make it sound natural and
              conversational)
            </li>
            <li>
              <b>Pro tip:</b> Have a friend or family member listen to it before
              uploading and have them provide feedback
            </li>
          </ul>
        </Grid>
      </React.Fragment>
    );
  }
}
